import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=e8f4628c&scoped=true"
import script from "./orderPage.vue?vue&type=script&lang=js"
export * from "./orderPage.vue?vue&type=script&lang=js"
import style1 from "./orderPage.vue?vue&type=style&index=1&id=e8f4628c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8f4628c",
  null
  
)

export default component.exports